import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";

import { Card } from "@/components/ui/card";
import { SkeletonRows } from "@/components/ui/skeleton";
import { useWikiPage } from "@/hooks/use-wiki";
import { WikiLabels } from "@/lib/labels/wiki";

import { WikiCreate } from "./-components/wiki-create";
import { WikiLayout } from "./-components/wiki-layout";
import { WikiPageView } from "./-components/wiki-page";

export const Route = createFileRoute("/_app/wiki/$slug")({
	component: WikiSlugPage,
});

function WikiSlugPage() {
	const { slug } = Route.useParams();
	const [creating, setCreating] = useState(false);

	const { data, isLoading, isError } = useWikiPage(slug);

	return (
		<WikiLayout
			activeSlug={slug}
			onCreate={() => setCreating(true)}
			onCloseCreate={() => setCreating(false)}
		>
			{() => (
				<>
					{isLoading && (
						<Card className="p-6 lg:p-8">
							<SkeletonRows rows={5} />
						</Card>
					)}

					{!isLoading && (isError || !data) && (
						<Card className="p-12 text-center">
							<p className="text-sm text-destructive">{WikiLabels.pageLoadError}</p>
						</Card>
					)}

					{!isLoading && data && <WikiPageView key={slug} page={data} />}

					{creating && <WikiCreate onClose={() => setCreating(false)} />}
				</>
			)}
		</WikiLayout>
	);
}
